import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  schoolCsvListAction,
  schoolReassignParentAction,
} from "../Redux/Action/schoolAction";
import { parentdetailsAction } from "../Redux/Action/parentAction";
import toast from "react-hot-toast";
import LoaderComponent from "../Components/common/LoaderComponent";
import "../Assets/css/school-selection-modal.css";

const AddParentOrganisationModal = ({
  show,
  onHide,
  parentdetails,
  idval,
}) => {
  const dispatch = useDispatch();
  const [schools, setSchools] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (show) {
      fetchSchools();
      setSelectedSchoolId(
        parentdetails?.schoolId?._id || parentdetails?.schoolId || "",
      );
      setSearchTerm("");
    }
  }, [show, parentdetails]);

  const fetchSchools = async () => {
    setLoading(true);
    try {
      const response = await dispatch(schoolCsvListAction());
      if (response?.payload?.statusCode === 200) {
        setSchools(response.payload.data || []);
      } else if (Array.isArray(response?.payload?.data)) {
        setSchools(response.payload.data);
      } else if (Array.isArray(response?.payload)) {
        setSchools(response.payload);
      } else {
        setSchools([]);
      }
    } catch (error) {
      console.error("Error fetching schools:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSchool = (schoolId) => {
    setSelectedSchoolId(schoolId);
  };

  const filteredSchools = schools.filter((school) => {
    const matchesSearch =
      school.schoolName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      school.email?.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesSearch;
  });

  const handleSubmit = async () => {
    if (!selectedSchoolId) {
      toast.error("Please select an organization");
      return;
    }
    setSubmitting(true);
    try {
      const payload = {
        parentId: idval,
        schoolId: selectedSchoolId,
      };

      const res = await dispatch(schoolReassignParentAction(payload));
      if (res?.payload?.statusCode == 200 || res?.payload?.status == 200) {
        toast.success(
          res?.payload?.message || "Organization assigned successfully!",
          {
            iconTheme: {
              primary: "#4318ff",
              secondary: "#FFFAEE",
            },
          },
        );
        dispatch(parentdetailsAction({ id: idval }));
        onHide();
      } else {
        toast.error(res?.payload?.message || "Failed to assign organization");
      }
    } catch (error) {
      toast.error("An error occurred while assigning organization");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="comn-modal-set school-selection-modal"
    >
      <Modal.Header closeButton className="border-none">
        <Modal.Title className="text-center w-100">
          Add to Organization
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 pb-2">
        <div className="search-wrapper">
          <span className="search-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
                fill="currentColor"
              />
            </svg>
          </span>
          <Form.Control
            placeholder="Search schools by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="school-table-container">
          {loading ? (
            <div className="text-center py-5">
              <LoaderComponent isInline={true} />
              <p className="mt-2 text-muted" style={{ fontSize: "14px" }}>
                Loading schools...
              </p>
            </div>
          ) : (
            <Table hover className="custom-table">
              <thead>
                <tr>
                  <th style={{ width: "50px" }}>Select</th>
                  <th>School Name</th>
                </tr>
              </thead>
              <tbody>
                {filteredSchools.length > 0 ? (
                  filteredSchools.map((school) => (
                    <tr
                      key={school._id}
                      onClick={() => handleSelectSchool(school._id)}
                      style={{ cursor: "pointer" }}
                    >
                      <td>
                        <div
                          className="custom-checkbox"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Form.Check
                            type="radio"
                            name="parentSchoolRadioGroup"
                            checked={selectedSchoolId === school._id}
                            onChange={() => handleSelectSchool(school._id)}
                          />
                        </div>
                      </td>
                      <td>{school.schoolName}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center py-5 text-muted">
                      No schools found matching "{searchTerm}"
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      </Modal.Body>
      <div className="modal-footer-custom">
        <Button className="btn-cancel" onClick={onHide} disabled={submitting}>
          Cancel
        </Button>
        <Button
          className="btn-submit-premium"
          onClick={handleSubmit}
          disabled={!selectedSchoolId || submitting}
        >
          {submitting ? "Saving..." : "Save"}
        </Button>
      </div>
    </Modal>
  );
};

export default AddParentOrganisationModal;
